import { tv } from 'tailwind-variants'

export const panelWrapperVariants = tv({
  base: 'z-[9999]',
  variants: {
    placement: {
      mobile: 'fixed bottom-[53px] left-1 right-1',
      desktop: 'absolute bottom-full right-0 w-[315px] mb-2'
    }
  },
  defaultVariants: {
    placement: 'desktop'
  }
})